import { apiRequestToastAsync } from "../../functions/FetchWithToast";
import {
    GET_ALL_DISCOUNT,
    GET_DISCOUNT_DETAIL_BY_ID,
    DELETE_DISCOUNTS_BY_ID,
    CREATE_DISCOUNT,
    UPDATE_DISCOUNT,
    PUT_DISCOUNTS_TO_VARIANTS,
    DELETE_DISCOUNTS_FROM_VARIANTS,
    DELETE_DISCOUNTS_BY_VARIANT_IDS,
    GET_ALL_DISCOUNTS_BY_TAG_ID,
    GET_DISCOUNTS_BY_TAG_ID,
    UPDATE_DISCOUNTS_BY_TAG_ID,
    DELETE_DISCOUNTS_BY_TAG_IDS,
    DELETE_DISCOUNTS_FROM_TAGS,
    PUT_DISCOUNTS_TO_TAGS
} from "../Api";

export const getAllDiscount = () => apiRequestToastAsync({
    request_details: GET_ALL_DISCOUNT,
    messages: {
        loading: 'Loading discounts',
        done: 'Discounts loaded',
        error: 'Error loading discounts'
    }
});
export const getDiscountDetailById = (id) => apiRequestToastAsync({
    request_details: GET_DISCOUNT_DETAIL_BY_ID(id),
    messages: {
        loading: 'Loading discount',
        done: 'Discount loaded',
        error: 'Error loading discount'
    }
});
export const deleteDiscountsByIds = (ids) => apiRequestToastAsync({
    request_details: DELETE_DISCOUNTS_BY_ID(ids),
    messages: {
        loading: 'Deleting discount',
        done: 'Discount deleted',
        error: 'Error deleting discount'
    }
});
export const createDiscount = (data) => apiRequestToastAsync({
    request_details: CREATE_DISCOUNT(data),
    messages: {
        loading: `Creating discount ${data.name}`,
        done: `Discount created  ${data.name}`,
        error: `Error creating discount  ${data.name}`
    }
});
export const updateDiscount = (data) => apiRequestToastAsync({
    request_details: UPDATE_DISCOUNT(data),
    messages: {
        loading: `Updating discount ${data.name}`,
        done: `Discount updated ${data.name}`,
        error: `Error updating discount ${data.name}`
    }
});
export const putDiscountsToVariants = (data) => apiRequestToastAsync({
    request_details: PUT_DISCOUNTS_TO_VARIANTS(data),
    messages: {
        loading: `Applying discounts to variants`,
        done: `Discounts applied`,
        error: `Error applying discounts to variants`
    }
});
export const deleteDiscountsFromVariants = (data) => apiRequestToastAsync({
    request_details: DELETE_DISCOUNTS_FROM_VARIANTS(data),
    messages: {
        loading: `Deleting discounts from variants`,
        done: `Discounts removed`,
        error: `Error deleting discounts from variants`
    }
});
export const deleteAllDiscountsFromVariants = (data) => apiRequestToastAsync({
    request_details: DELETE_DISCOUNTS_BY_VARIANT_IDS(data),
    messages: {
        loading: `Deleting discounts from variants`,
        done: `Discounts removed`,
        error: `Error deleting discounts from variants`
    }
});
export const getAllDiscountsByTagId = (data) => apiRequestToastAsync({
    request_details: GET_ALL_DISCOUNTS_BY_TAG_ID(data),
    messages: {
        loading: `Deleting discounts from variants`,
        done: `Discounts removed`,
        error: `Error deleting discounts from variants`
    }
});
export const storeAllDiscount = (discounts) => ({
    type: 'ALL_DISCOUNTS',
    payload: discounts
});

export const putDiscountsToTags = (data) => apiRequestToastAsync({
    request_details: PUT_DISCOUNTS_TO_TAGS(data),
    messages: {
        loading: `Applying discounts to tags`,
        done: `Discounts applied`,
        error: `Error applying discounts to tags`
    }
});
export const deleteDiscountsFromTags = (data) => apiRequestToastAsync({
    request_details: DELETE_DISCOUNTS_FROM_TAGS(data),
    messages: {
        loading: `Deleting discounts from tags`,
        done: `Discounts removed`,
        error: `Error deleting discounts from tags`
    }
});
export const deleteAllDiscountsFromTags = (data) => apiRequestToastAsync({
    request_details: DELETE_DISCOUNTS_BY_TAG_IDS(data),
    messages: {
        loading: `Deleting discounts from tags`,
        done: `Discounts removed`,
        error: `Error deleting discounts from tags`
    }
});
export const updateDiscountsByTagId = (id, data) => apiRequestToastAsync({
    request_details: UPDATE_DISCOUNTS_BY_TAG_ID(id, data),
    messages: {
        loading: `Updating discounts for tag ${id}`,
        done: `Updated discounts for tag ${id}`,
        error: `Error updating discounts for tag ${id}`
    }
});

export const getDiscountsByTagId = (id) => apiRequestToastAsync({
    request_details: GET_DISCOUNTS_BY_TAG_ID(id),
    messages: {
        loading: `Featching discounts for tag ${id}`,
        done: `Loaded discounts for tag ${id}`,
        error: `Error discounts for tag ${id}`
    }
});